var _defs, _path, _path2, _path3, _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 63 63",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:3px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m43.215 32.121a11.261 11.295 0 0 0-0.2931-2.5416l2.7514-1.5838-3.5077-5.9462-2.7041 1.5838a11.809 11.845 0 0 0-4.2452-2.6269v-2.9399h-6.8548v2.9589a11.847 11.883 0 0 0-4.2358 2.6269l-2.7041-1.6027-3.4605 5.9272 2.7041 1.5838a11.261 11.295 0 0 0-0.2931 2.5416 11.128 11.162 0 0 0 0.2931 2.5416l-2.7041 1.6312 3.4605 5.9367 2.7041-1.5838a11.582 11.617 0 0 0 4.2358 2.4562v3.1296h6.8548v-3.1296a11.544 11.579 0 0 0 4.2452-2.4562l2.7041 1.5838 3.5077-5.9367-2.7514-1.6122a11.128 11.162 0 0 0 0.2931-2.5416z",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m26.083 32.121a5.6729 5.6901 0 1 0 5.6729-5.6901 5.6729 5.6901 0 0 0-5.6729 5.6901z",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m31.491 7.1034a24.327 24.401 0 1 0 12.547 3.4899",
    strokeWidth: 2.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    transform: "matrix(.94548 0 0 .94835 5.7358 5.6809)",
    points: "41.44 10.67 40.43 5.06 46.04 4.04",
    strokeWidth: 2.6402
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.cf5d0717905d046955e6de90b9453402.svg";
export { ForwardRef as ReactComponent };